import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, type WithHydraPagination } from '~/api/utils'
import type { SmsTemplateResponse } from '../types'

export const useSmsTemplates = ({
  forApplicant,
  forContact
}: {
  forApplicant?: boolean
  forContact?: boolean
} = {}) => {
  const params = new URLSearchParams()
  if (forApplicant !== undefined)
    params.set('forApplicant', String(forApplicant))
  if (forContact !== undefined) params.set('forContact', String(forContact))
  const query = params.toString()

  return useQuery<WithHydraPagination<SmsTemplateResponse>>({
    queryKey: ['sms-templates', { forApplicant, forContact }],
    queryFn: ({ signal }) =>
      fetchApiWithToken<WithHydraPagination<SmsTemplateResponse>>({
        url: `/v1/sms_templates${query ? `?${query}` : ''}`,
        useLDJson: true,
        signal
      }),
    staleTime: 60_000
  })
}
